import React, {useEffect} from "react";
import Styles from './styles.module.scss';

import {useTranslation} from "react-i18next";
import telIcon from "../../theme/assets/svg/lp_soc_tel_icon.svg";
import ytIcon from "../../theme/assets/svg/lp_soc_yt_icon.svg";
import disIcon from "../../theme/assets/svg/lp_soc_dis_icon.svg";
import Logo from "../_UI/logo";
import {useNavigate} from "react-router-dom";
import {useSelector} from "react-redux";

const CabinetComingSoon = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const authStatus = useSelector(store => store.main.authorizationStatus);

    useEffect(()=>{
        if (!authStatus){
            navigate('/sign-up');
        }
    },[authStatus, navigate])

    return (
        <section className={`${Styles.container} ${Styles.pageContainer}`}>
            <div className={`${Styles.contentWrap}`}>
                <div className={`${Styles.contentWrapTitle}`}>{t('Спасибо за регистрацию!')}</div>
                <div className={`${Styles.contentWrapSubTitle}`}>{t('Следите за обновлениями — запуск состоится в ближайшее время. Благодарим за ваше терпение и интерес!')}</div>
                <div className={`${Styles.socWrap}`}>
                    <div className={`${Styles.socWrapTitle}`}>{t('Следите за нами в социальных сетях, чтобы быть в курсе обновлений:')}</div>
                    <div className={`${Styles.socBox}`}>
                        <div
                            className={`${Styles.socItem}`}
                            onClick={() => {
                                window.open("https://t.me/officialOMT", "_blank");
                            }}
                        >
                            <img src={telIcon} alt="Telegram"/>
                        </div>
                        <div
                            className={`${Styles.socItem}`}
                            onClick={() => {
                                window.open("https://www.youtube.com/channel/UCDx29CIHFou4lrdIDHBRmiw", "_blank");
                            }}
                        >
                            <img src={ytIcon} alt="YouTube"/>
                        </div>
                        <div
                            className={`${Styles.socItem}`}
                            onClick={() => {
                                window.open("https://discord.gg/YWMJkwkg74", "_blank");
                            }}
                        >
                            <img src={disIcon} alt="Discord"/>
                        </div>
                    </div>
                </div>
                <div className={`${Styles.logoWrap}`}>
                    <Logo/>
                </div>
            </div>
        </section>
    );
};

export default CabinetComingSoon;